import { isUnset } from './utilities'

const isNonFiniteNumber = (value: string | number): boolean =>
    typeof value === 'number' && Number.isNaN(value)

export const formatDecimal = (value?: string | number): string => {
    if (isUnset(value)) {
        return ''
    }
    if (value === '' || isNonFiniteNumber(value)) {
        return ''
    }
    const parts = value.toString().split('.')
    return parts
        .map((p, i) => {
            if (i > 0) {
                return p
            }
            return p.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
        })
        .join('.')
}

export const parseDecimal = (value?: string): string =>
    (value ?? '').replace(/(,*)/g, '')

export const parseCurrency = (value?: string | number): string => {
    if (isUnset(value)) {
        return ''
    }
    if (value === '' || isNonFiniteNumber(value)) {
        return ''
    }
    const parts = value.toString().split(' ')
    // everything before the last space is the currency symbol
    return parseDecimal(parts[parts.length - 1])
}

export const formatPercentageInput = (value?: string | number): string => {
    if (isUnset(value)) {
        return ''
    }
    if (value === '' || isNonFiniteNumber(value)) {
        return ''
    }
    return `${value}%`
}

export const parsePercentageInput = (value?: string): string => {
    if (isUnset(value)) {
        return ''
    }
    if (value === '') {
        return ''
    }
    return value.replace('%', '')
}

// Numeric rounding (returns number: 10.6885 -> 10.69, 10.6985 -> 10.7, 10.6845 -> 10.68)
export const roundTo2Decimals = (n: number): number =>
    Math.round((n + Number.EPSILON) * 100) / 100
